import React from 'react'
import Card from '@mui/material/Card'
import Image from 'next/image'
import Link from 'next/link'

const DATA = [
  {
    id: 1,
    time: 'December 12',
    shorts: [
      {
        id: 19,
        img: '/images/youtube/shorts1.jpg',
        title: 'comedy 🤭',
        url: 'https://www.youtube.com/shorts/rTx4G39R1YA'
      },
      {
        id: 20,
        img: '/images/youtube/shorts2.jpg',
        title: 'The Most Insane Coke Explosion Ever Done In A ROOM!',
        url: 'https://www.youtube.com/shorts/hkaktmrgXLM'
      },
      {
        id: 21,
        img: '/images/youtube/shorts3.jpg',
        title: '100 PB&J’s For People in Need',
        url: 'https://www.youtube.com/shorts/3STADyXOtRA'
      },
      {
        id: 22,
        img: '/images/youtube/shorts4.jpg',
        title: 'How to protect yourself From The enemy That Using Martial Arts  part 2593',
        url: 'https://www.youtube.com/shorts/_-k9_FlQj8E'
      }
    ],
    data: [
      {
        id: 1,
        img: '/images/youtube/1.jpg',
        title: 'Douyin Tiktok | Beauty #313',
        author: 'hello media',
        time: 'Views: 5.2M times',
        titles:
          'Thanks for watching!❤Channel update everyday!❤❤ ✓ remember Like and Subscribe this channel! ✓ remember Leave a ...',
        url: 'https://www.youtube.com/watch?v=1Y8RfCQHveE&t=20s'
      },
      {
        id: 2,
        img: '/images/youtube/2.jpg',
        title: 'Barbie | Teaser Trailer',
        author: 'Warner Bros. Pictures',
        time: 'Views: 5.2M times',
        titles: '#BarbieTheMovie, from director Greta Gerwig, only in theatres Summer 2023',
        url: 'https://www.youtube.com/watch?v=8zIf0XvoL9Y&t=1s'
      },
      {
        id: 3,
        img: '/images/youtube/3.jpg',
        title: 'Avicii, Dua Lipa, Coldplay, Martin Garrix & Kygo, The Chainsmokers Style - Feeling Me',
        author: 'XDeep Vibes',
        time: '83 people are watching',
        titles:
          '#DeepHouse #VocalHouse #DeepHouseMix Avicii, Dua Lipa, Coldplay, Martin Garrix & Kygo, The Chainsmokers Style - Feeling Me All songs in this spotify playlist: https://spoti.fi/2TJ4Dyj 🚫...',
        url: 'https://www.youtube.com/watch?v=B7v2L7VvaaM'
      },
      {
        id: 4,
        img: '/images/youtube/4.jpg',
        title:
          '[4K] [180518] MOMOLAND (Yeonwoo Yeonwoo) - BBoom BBoom (Korea Polytechnic University Jeongsu Campus Festival) Fancam by PIERCE',
        author: 'PIERCE',
        time: 'Views: 9.6M times',
        titles:
          'MOMOLAND (Yeonwoo) : 「BBoom BBoom」 4K60p fancam by PIERCE - May 18, 2018 @ KOREA POLYTECHNICS FESTIVAL - Dont make any modification and re-upload.',
        url: 'https://www.youtube.com/watch?v=xmESOGcXjmI'
      },
      {
        id: 5,
        img: '/images/youtube/5.jpg',
        title: 'Douyin Tiktok | Beauty #89',
        author: 'hello media',
        time: 'Number of views: 320K times',
        titles:
          '❤❤Thanks for watching! ❤Channel update everyday! ❤❤✓ remember Like and Subscribe this channel!✓ remember Leave a comment! ✓ Wish you all have fun!',
        url: 'https://www.youtube.com/watch?v=Ug0_9zaJpmE&t=4s'
      }
    ]
  },
  {
    id: 6,
    time: 'December 9',
    data: [
      {
        id: 7,
        img: '/images/youtube/7.jpg',
        title: '35 Times Animals Messed With Wrong Opponents',
        author: 'Interesting Facts',
        time: 'Views: 5.5M times',
        titles:
          '► Subscribe: https://goo.gl/vHN6qB35 Times Animals Messed With Wrong Opponents For copyright matters please contact us at: miniminter1992.29@gmail.com',
        url: 'https://www.youtube.com/watch?v=9fidvRneoK4'
      },
      {
        id: 8,
        img: '/images/youtube/8.jpg',
        title: 'How to Make Video Calls | WhatsApp',
        author: 'WhatsApp',
        time: 'Views: 3.8M times',
        titles:
          'Learn how to make video calls on WhatsApp. Video calling on WhatsApp lets you see a video of the person you’re calling while chatting.To make a video call, open the WhatsApp chat with...',
        url: 'https://www.youtube.com/watch?v=QkvlYq9TazU'
      },
      {
        id: 9,
        img: '/images/youtube/9.jpg',
        title: 'How to send view once photos and videos on WhatsApp',
        author: 'WhatsApp',
        time: 'Views: 5M times',
        titles:
          'Learn how to send and open view-once photos and videos from your WhatsApp chat.https://faq.whatsapp.com/android/chats/how-to-send-and-open-view-once-media To see more #WhatsAppTutorials,...',
        url: 'https://www.youtube.com/watch?v=QSZaUld5I3E'
      }
    ]
  },
  {
    id: 10,
    time: 'December 12',
    data: [
      {
        id: 11,
        img: '/images/youtube/11.jpg',
        title: 'AVATAR 2 THE WAY OF WATER : 6 Minute Extended Trailer (4K ULTRA HD) 2022',
        author: 'TrailerSpot',
        time: 'Views: 2.3M times',
        titles: 'Trailer For Avatar 2 The Way Of Water',
        url: 'https://www.youtube.com/watch?v=6_-6g9pKK9g&t=1s'
      }
    ]
  }
]

function Youtub() {
  const History = index => {
    return DATA[index].data.map(item => {
      return (
        <Link href={item.url} key={item.id}>
          <div className='flex mt-2'>
            <div className=''>
              <Image
                src={item.img}
                alt='img'
                width={246}
                height={138}
                className='w-full h-[120px] rounded-lg sm:h-[65px]'
              />
            </div>
            <div className='ml-4 w-9/12 sm:w-2/5'>
              <div className=''>
                <h2 className='text-[18px] font-[400] truncate sm:text-[13px]'>{item.title}</h2>
              </div>
              <div className='md:flex items-center mt-1.5 text-[12px]'>
                <p className='text-black text-opacity-85 mr-1'>{item.author}</p>
                <i className='sm:hidden'>•</i>
                <p className='text-black text-opacity-85 md:ml-1'>{item.time}</p>
              </div>
              <div className='mt-2 h-[40px] overflow-clip'>
                <p className='text-[13px] text-[#606060] sm:hidden '>{item.titles}</p>
              </div>
            </div>
          </div>
        </Link>
      )
    })
  }

  const Shorts = index => {
    return DATA[index].shorts.map(item => {
      return (
        <div key={item.id} className=''>
          <Link href={item.url}>
            <div>
              <ul>
                <Image src={item.img} width={10} height={10} className='w-full h-full rounded-xl' alt='img' />
                <p className='text-[13px] font-medium mt-2  w-10/12 truncate'>{item.title}</p>
              </ul>
            </div>
          </Link>
        </div>
      )
    })
  }

  return (
    <Card sx={{ marginLeft: 'auto', marginRight: 'auto' }} className='sm:w-11/12'>
      <div className=''>
        <div className='w-[90%] mx-auto rounded-lg '>
          <div className='mx-auto p-2'>
            <div>
              <h2 className='text-[16px] font-medium'>Watch History</h2>
            </div>
            {DATA.map((item, index) => {
              return (
                <div key={index} className='mt-6 w-11/12'>
                  <h2 className='text-[16px] font-medium'>{item.time}</h2>
                  {DATA[index].shorts ? (
                    <div className=' border-b-[1px] h-full p-4'>
                      <div className='flex mt-6'>
                        <Image src='/images/youtube/short.png' width={24} height={24} alt='short' />
                        <h2 className='font-medium ml-2'>Shorts</h2>
                      </div>
                      <div className='w-[70%] grid  grid-cols-4 gap-y-6 gap-x-4 mt-4'>{Shorts(index)}</div>
                    </div>
                  ) : (
                    ''
                  )}
                  <br></br>
                  {DATA[index].data ? <div>{History(index)}</div> : ''}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Card>
  )
}

export default Youtub
